<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> ایجاد مدیر زبان جدید </template>
    <BRow>
      <BCol cols="12" md="6">
        <LanguagePicker
          placeHolder="زبان مورد نظر"
          @getLanguage="setLanguageId"
        ></LanguagePicker>
      </BCol>
      <BCol cols="12" md="6">
        <UserPicker @getUser="setUserId"></UserPicker>
      </BCol>
      <BCol cols="12" md="6">
        <IndependentLessonPicker
          is-multiple
          :languageId="languageManagerPayload.languageId"
          @getLesson="setLessons"
        ></IndependentLessonPicker>
      </BCol>
      <BCol cols="12" md="6">
        <LessonCategoryPicker
          is-multiple
          @getLessonCategory="setLessonCategories"
        ></LessonCategoryPicker>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="userPercentIncome"
          inputLabel="درصد سود کاربر"
          inputPlaceholder="30"
          v-model="computedUserPercentIncome"
        >
          <template #append> % </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          readonly
          disabled
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="fermanPercentIncome"
          inputLabel="درصد سود فرمن"
          inputPlaceholder="70"
          v-model="languageManagerPayload.fermanPercentIncome"
        >
          <template #append> % </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" class="d-flex align-items-center justify-content-end">
        <BButton @click="createANewLanguageManager" variant="success">
          ایجاد مدیر زبان
        </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      selectedLanguage: null,
      selectedUser: null,
      languageManagerPayload: {
        languageId: null,
        userId: null,
        fermanPercentIncome: null,
        userPercentIncome: null,
        lessonIds: [],
        lessonCategoryIds: [],
      },
    };
  },
  methods: {
    setLessonCategories(lessonCategoryIds) {
      this.languageManagerPayload.lessonCategoryIds = lessonCategoryIds;
    },
    setLessons(lessonIds) {
      this.languageManagerPayload.lessonIds = lessonIds;
    },
    setLanguageId(languageId) {
      this.languageManagerPayload.languageId = languageId;
    },
    setUserId(userId) {
      this.languageManagerPayload.userId = userId;
    },
    async createANewLanguageManager() {
      try {
        this.isLoading = true;
        const _this = this;
        const createLanguageManager = new CreateLanguageManager(_this);
        createLanguageManager.setRequestParamDataObj(
          _this.languageManagerPayload
        );
        await createLanguageManager.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "مدیر زبان با موفقیت ایجاد شد.",
              },
            });
            _this.languageManagerPayload = {
              languageId: null,
              userId: null,
              fermanPercentIncome: null,
              userPercentIncome: null,
              lessonIds: [],
              lessonCategoryIds: [],
            };
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    computedUserPercentIncome: {
      set(val) {
        this.languageManagerPayload.userPercentIncome = val;
        this.languageManagerPayload.fermanPercentIncome = 100 - val;
      },
      get() {
        return this.languageManagerPayload.userPercentIncome;
      },
    },
  },
  components: {
    CustomAppendText,
    PageWrapper,
    TextInput,
    LanguagePicker,
    UserPicker,
    IndependentLessonPicker,
    LessonCategoryPicker,
    BCol,
    BRow,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import UserPicker from "@/views/components/Users/UserPicker.vue";
import IndependentLessonPicker from "@/views/components/Lessons/IndependentLessonPicker.vue";
import LessonCategoryPicker from "@/views/components/LessonCategories/LessonCategoryPicker.vue";
import { BCol, BRow, BButton } from "bootstrap-vue";
import { CreateLanguageManager } from "@/libs/Api/LanguageManagers";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
</script>
